import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_ctx.showSummaryPanel)
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        style: {"border-top-right-radius":"0px !important","border-bottom-right-radius":"0px !important"},
        class: "default_card_wm elevation-0 pa-2 mb-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, { "no-gutters": "" }, {
            default: _withCtx(() => [
              (_ctx.noVat && !_ctx.vatAmountToRemove)
                ? (_openBlock(), _createBlock(_component_v_col, {
                    key: 0,
                    cols: "12",
                    class: "d-flex justify-center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_alert, {
                        border: "start",
                        width: "90%",
                        color: "warning",
                        icon: "$warning",
                        "model-value": true,
                        variant: "text"
                      }, {
                        default: _withCtx(() => _cache[1] || (_cache[1] = [
                          _createTextVNode(" Pas de TVA à déclarer ")
                        ])),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_v_col, {
                      cols: "12",
                      class: "mx-2 my-2 pr-4 d-flex justify-space-between align-center"
                    }, {
                      default: _withCtx(() => [
                        _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Récapitulatif", -1)),
                        (_ctx.showSummaryPanel)
                          ? (_openBlock(), _createBlock(_component_v_btn, {
                              key: 0,
                              size: "small",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showSummaryPanelAction()))
                            }, {
                              default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createTextVNode("Masquer")
                              ])),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    (
                        _ctx.totalCollVat.totalBase ||
                        _ctx.totalPurchasesIntracomBase ||
                        _ctx.totalImportBase ||
                        _ctx.totalReverseChargeBase
                    )
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 0,
                          cols: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, { class: "mb-2 py-2 rounded-xl border" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, {
                                  class: "body-1 font-weight-bold",
                                  style: {"font-size":"0.875em"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => _cache[4] || (_cache[4] = [
                                            _createTextVNode(" Opérations taxées : ")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.totalCollVat.totalBase)
                                      ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "9" }, {
                                              default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                _createTextVNode("Ventes, services :")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex justify-end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalCollVat.totalBase)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.totalImportBase)
                                      ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "9" }, {
                                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                                _createTextVNode(" Importations : ")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex justify-end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalImportBase)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.totalPurchasesIntracomBase)
                                      ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "9",
                                              class: "text-truncate"
                                            }, {
                                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                _createTextVNode(" Acquisitions intracommunautaires : ")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex justify-end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalPurchasesIntracomBase)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.totalReverseChargeBase)
                                      ? (_openBlock(), _createBlock(_component_v_row, { key: 3 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "9",
                                              class: "text-truncate"
                                            }, {
                                              default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                _createTextVNode(" Autres opérations imposables : ")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex justify-end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalReverseChargeBase)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.totalExportBase || _ctx.totalNonTaxableBase || _ctx.totalSalesIntracomBase)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 1,
                          cols: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, { class: "mb-2 py-2 rounded-xl border" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, {
                                  class: "body-1 font-weight-bold",
                                  style: {"font-size":"0.875em"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => _cache[9] || (_cache[9] = [
                                            _createTextVNode(" Opérations non taxées : ")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.totalExportBase)
                                      ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, { cols: "9" }, {
                                              default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                _createTextVNode("Exportations hors UE :")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex justify-end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalExportBase)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.totalNonTaxableBase)
                                      ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "9",
                                              class: "text-truncate"
                                            }, {
                                              default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                _createTextVNode("Autres opérations non imposables :")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex justify-end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalNonTaxableBase)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.totalSalesIntracomBase)
                                      ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "9",
                                              class: "text-truncate"
                                            }, {
                                              default: _withCtx(() => _cache[12] || (_cache[12] = [
                                                _createTextVNode("Livraisons intracommunautaires :")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex justify-end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalSalesIntracomBase)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (
                        _ctx.totalCollVat.totalBase ||
                        _ctx.totalCollVat.totalCollIntracom ||
                        _ctx.totalCollVat.grandTotal
                    )
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 2,
                          cols: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, { class: "mb-2 py-2 rounded-xl border" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, {
                                  class: "body-1 font-weight-bold",
                                  style: {"font-size":"0.875em"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, {
                                      "no-gutters": "",
                                      class: "mb-2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => _cache[13] || (_cache[13] = [
                                            _createTextVNode(" TVA brute : ")
                                          ])),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.totalCollVat[2.1].net)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 0,
                                          "no-gutters": "",
                                          class: "mb-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "2",
                                              class: "d-flex justify-start"
                                            }, {
                                              default: _withCtx(() => _cache[14] || (_cache[14] = [
                                                _createTextVNode(" 2,1 % : ")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "5",
                                              class: "d-flex justify-start"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" HT : " + _toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalCollVat[2.1].net)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "5",
                                              class: "d-flex justify-end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" TVA : " + _toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalCollVat[2.1].vat)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.totalCollVat[5.5].net)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 1,
                                          "no-gutters": "",
                                          class: "mb-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "2",
                                              class: "d-flex justify-start"
                                            }, {
                                              default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                _createTextVNode(" 5,5 % : ")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "5",
                                              class: "d-flex justify-start"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" HT : " + _toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalCollVat[5.5].net)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "5",
                                              class: "d-flex justify-end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" TVA : " + _toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalCollVat[5.5].vat)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.totalCollVat[8.5].net)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 2,
                                          "no-gutters": "",
                                          class: "mb-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "2",
                                              class: "d-flex justify-start"
                                            }, {
                                              default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                _createTextVNode(" 8,5 % : ")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "5",
                                              class: "d-flex justify-start"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" HT : " + _toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalCollVat[8.5].net)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "5",
                                              class: "d-flex justify-end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" TVA : " + _toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalCollVat[8.5].vat)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.totalCollVat[10].net)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 3,
                                          "no-gutters": "",
                                          class: "mb-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "2",
                                              class: "d-flex justify-start"
                                            }, {
                                              default: _withCtx(() => _cache[17] || (_cache[17] = [
                                                _createTextVNode(" 10 % : ")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "5",
                                              class: "d-flex justify-start"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" HT : " + _toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalCollVat[10].net)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "5",
                                              class: "d-flex justify-end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" TVA : " + _toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalCollVat[10].vat)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.totalCollVat[20].net)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 4,
                                          "no-gutters": "",
                                          class: "mb-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "2",
                                              class: "d-flex justify-start"
                                            }, {
                                              default: _withCtx(() => _cache[18] || (_cache[18] = [
                                                _createTextVNode(" 20 % : ")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "5",
                                              class: "d-flex justify-start"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" HT : " + _toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalCollVat[20].net)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "5",
                                              class: "d-flex justify-end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" TVA : " + _toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalCollVat[20].vat)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.totalCollVat.grandTotal)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 5,
                                          "no-gutters": "",
                                          class: "mt-3"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "9",
                                              class: "d-flex justify-start"
                                            }, {
                                              default: _withCtx(() => _cache[19] || (_cache[19] = [
                                                _createTextVNode(" Total TVA brute due : ")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex justify-end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalCollVat.grandTotal)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true),
                                    (_ctx.totalCollVat.totalCollIntracom)
                                      ? (_openBlock(), _createBlock(_component_v_row, {
                                          key: 6,
                                          "no-gutters": "",
                                          class: "mt-1"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "9",
                                              class: "text-truncate"
                                            }, {
                                              default: _withCtx(() => _cache[20] || (_cache[20] = [
                                                _createTextVNode(" Dont TVA/acquisitions intracommunautaires : ")
                                              ])),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "3",
                                              class: "d-flex justify-end"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalCollVat.totalCollIntracom)),
                                        )), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item, { class: "mb-2 py-2 rounded-xl border" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, {
                              class: "body-1 font-weight-bold",
                              style: {"font-size":"0.875em"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  style: _normalizeStyle({ color: _ctx.totalDedVat.grandTotal < 0 && 'red' })
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "9" }, {
                                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                                        _createTextVNode(" TVA déductible : ")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      class: "d-flex justify-end"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.previousVatCredit?.vatAmount
                                            ? _ctx.formatCurrencyWithoutDecimals(
                                                  Math.round(
                                                      _ctx.totalDedVat.grandTotal +
                                                          _ctx.previousVatCredit.vatAmount,
                                                  ),
                                              )
                                            : _ctx.formatCurrencyWithoutDecimals(
                                                  Math.round(_ctx.totalDedVat.grandTotal),
                                              )), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["style"]),
                                (_ctx.totalDedVat.totalDedFixedAssets)
                                  ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "9",
                                          class: "text-truncate"
                                        }, {
                                          default: _withCtx(() => _cache[22] || (_cache[22] = [
                                            _createTextVNode(" Dont TVA sur immobilisations : ")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          class: "d-flex justify-end"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalDedVat.totalDedFixedAssets)),
                                        )), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "9",
                                      class: "text-truncate"
                                    }, {
                                      default: _withCtx(() => _cache[23] || (_cache[23] = [
                                        _createTextVNode(" Dont TVA sur autres biens et services : ")
                                      ])),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      class: "d-flex justify-end"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.round(
                                                _ctx.totalDedVat.grandTotal -
                                                    _ctx.totalDedVat.totalDedFixedAssets -
                                                    _ctx.totalDedVat.totalDedImport,
                                            ),
                                        )), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                (_ctx.totalDedVat.totalDedImport)
                                  ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "9",
                                          class: "text-truncate"
                                        }, {
                                          default: _withCtx(() => _cache[24] || (_cache[24] = [
                                            _createTextVNode(" Dont TVA sur importations : ")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          class: "d-flex justify-end"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalDedVat.totalDedImport)),
                                        )), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                (_ctx.previousVatCredit)
                                  ? (_openBlock(), _createBlock(_component_v_row, { key: 2 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "9",
                                          class: "text-truncate"
                                        }, {
                                          default: _withCtx(() => _cache[25] || (_cache[25] = [
                                            _createTextVNode(" Dont crédit période précédente : ")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          class: "d-flex justify-end"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(_ctx.previousVatCredit.vatAmount),
                                        )), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.vatAmountToRemove)
                      ? (_openBlock(), _createBlock(_component_v_col, {
                          key: 3,
                          cols: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, { class: "mb-2 py-2 rounded-xl border" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, {
                                  class: "body-1 font-weight-bold",
                                  style: {"font-size":"0.875em"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "9",
                                          class: "text-truncate"
                                        }, {
                                          default: _withCtx(() => _cache[26] || (_cache[26] = [
                                            _createTextVNode(" Total à déclarer plus tard ")
                                          ])),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, {
                                          cols: "3",
                                          class: "d-flex justify-end"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.vatAmountToRemove)),
                                        )), 1)
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_v_col, { cols: "12" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item, { class: "mb-2 py-2 rounded-xl border" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item_title, {
                              class: "body-1 font-weight-bold",
                              style: {"font-size":"0.875em"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "9" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.totalVat <= 0 ? "Crédit de TVA" : "Total à décaisser"), 1)
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "3",
                                      class: "d-flex justify-end"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.formatCurrencyWithoutDecimals(
                                            Math.abs(Math.round(_ctx.totalVat)),
                                        )), 1)
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 64))
            ]),
            _: 1
          })
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}